import { render, staticRenderFns } from "./PricingSuperAdmin.vue?vue&type=template&id=728cb9b8&"
import script from "./PricingSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./PricingSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports